import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lic_gastro',
  templateUrl: './lic_gastro.component.html',
  styleUrls: ['./lic_gastro.component.css']
})
export class Lic_gastroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
